import { IError } from "itsf-ui-common";
import { Fragment, ReactNode } from "react";
import { Error } from "./Error";
import { Loader } from "../Loader/Loader";

interface ILoaderAndError {
    children: ReactNode;
    error?: IError;
    isHomePage?: boolean;
    isLoading: boolean;
    retryFetch?(): void;
    skeleton?: ReactNode;
}

export const HandleErrorAndLoading = (props: ILoaderAndError) => {
    const { children, isHomePage, error, isLoading, retryFetch, skeleton } = props;
    const showLoader = !error && isLoading;

    let element = children;

    if (error) {
        element = <Error error={error} isHomePage={isHomePage} retryFetch={retryFetch} />;
    } else if (showLoader) {
        element = skeleton ?? <Loader />;
    }

    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <Fragment>{element}</Fragment>;
};
